export default "__VITE_ASSET__DqySfQRT__"